import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { GenerateFileInterfaceModalComponent } from 'src/app/shared/components/modals/generate-file-interface-modal/generate-file-interface-modal.component';
import { BcModel } from 'src/app/shared/models/societe-linked/bc/bc.model';
import { ModalImportBcComponent } from '../bc/modals/modal-import-bc/modal-import-bc.component';
import { InterfaceService } from 'src/app/shared/services/interface-service';

@Component({
  selector: 'app-interface',
  templateUrl: './interface.component.html',
  styleUrls: ['./interface.component.scss']
})
export class InterfaceComponent implements OnInit {
  importedBc: BcModel = new BcModel();
  canImport = false ;
  canGenerate = false;
  constructor(public dialog: MatDialog,
              private interfaceService: InterfaceService,
              public router: Router
              ) { }

  ngOnInit(): void {
    const user = JSON.parse(localStorage.getItem('CURRENT_USER'));
    const droitsGenerate = user.droits.filter(droit =>
        (droit.niveau === 5 || droit.niveau === 10) &&
        (droit.type.toUpperCase() === 'INTERFACE')
    );
    const droitsImport = user.droits.filter(droit =>
        (droit.niveau === 2 || droit.niveau === 3 || droit.niveau === 4 || droit.niveau === 10) &&
        (droit.type.toUpperCase() === 'INTERFACE')
    );

    if (droitsGenerate && droitsGenerate.length > 0){
      this.canGenerate = true;
    }
    if (droitsImport && droitsImport.length > 0){
      this.canImport = true;
    }
  }

  openInterface(): void {
    const dialogConfirmation = this.dialog.open(GenerateFileInterfaceModalComponent, {
      disableClose: true,
      data: {
        title: 'Interface Sage',
        subTitle: '',
        dialogWidth: '100px',
        color: 'primary',
        icon_color: 'accent',
      }
    });
    dialogConfirmation.afterClosed().subscribe(res => {
    });
  }

  getBcToImport(): void {
    this.dialog.open(ModalImportBcComponent, {
      disableClose: true,
      data: {
        importedBc: this.importedBc
      }
    });
  }

  getOtherBcToImport(): void {
    this.dialog.open(ModalImportBcComponent, {
      disableClose: true,
      data: {
        importedBc: this.importedBc
      }
    });
  }
}
